import React, { useEffect, useState } from "react";
import { Loader } from "../Global/Loader";
import { base_url } from "../Api/Api";
import ItemEducation from "../MainPage/itemEducation";
import Header from "../Global/Header";

const SuggestionCourse = (props) => {
  const [state, setState] = useState({
    data: [],
    loader: true,
  });

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("logined")) == null) {
      props.history.push(`/Entrance`);
    }


    base_url
      .get("recommend_items",)
      .then((response) => {
        setState({
          ...state,
          data: response.data.recommendItems,
          loader: false,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  }, []);

  return (
    <div className="instructpg suggestion-course">
      <Loader active={state.loader} />
      <Header innerPage={true} title={"کورس های پیشنهادی"} />
      <div className="row-courses">
        {state.data.length === 0 ? (
          <span className="no-content">اطلاعاتی وجود ندارد</span>
        ) : (
          state.data.map((info) => <ItemEducation type="course" data={info} />)
        )}
      </div>
    </div>
  );
};

export default SuggestionCourse;
